import React from 'react';
import SettingsPage from '@/pageComponents/Settings';

const PaymentMethods = () => (
    <SettingsPage pathname="/settings/payment-methods" />
);

export default PaymentMethods;
